import { NeutralButton } from "./Buttons"
import { useTranslation } from "react-i18next"
import ReusableDrawer from "./ReusableDrawer"

export default function ActionConfirmDrawer({
  body, isOpen, bgColor, onClose, title, onConfirm, onCancel,
  showSpinner = false, confirmText = null, cancelText = null, subtext = null, size = 'xs',
  bodyStyle = "flex flex-col items-center justify-center text-center",
  isConfirming = false, renderTrigger = true
}) {
  const { t } = useTranslation()

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      placement={'bottom'}
      bodyContent={body}
      title={title}
      bgColor={bgColor}
      size={size}
      renderTrigger={renderTrigger}
      titleStyle={"flex items-center justify-center w-full"}
      bodyStyle={bodyStyle}
      footerStyle="flex items-center justify-center w-full"
      footerContent={
        <div className="flex my-4 gap-2">
          <NeutralButton
            text={confirmText || t('Confirm')}
            onClick={onConfirm}
            loading={isConfirming}
            disabled={isConfirming}
          />
          <NeutralButton
            text={cancelText || t('Cancel')}
            onClick={onCancel}
            disabled={isConfirming}
          />
        </div>
      }
    />
  )
}